import React from 'react';

const Flag = ({ countryCode, locale, size, rounded, square }) => {
  let code = countryCode;
  if (locale) {
    [, code] = locale.split('-');
  }

  return (
    code ? <span className={`fp ${code.toLowerCase()} ${size ? `fp-${size}` : ''} ${rounded ? 'fp-rounded' : ''} ${square ? 'fp-square' : ''}`} /> : null
  );
};

export default Flag;
